import styled from 'styled-components';

export const CustomAlarmsContent = styled.div`
    margin: 0 24px;
`;

export const CustomNotificationsActionsRow = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 0.3125rem 0 1.5rem;
`;

export const CustomNotificationsTableContainer = styled.div`
    padding-bottom: 32px;
`;

export const CustomAlarmModalContent = styled.div`
    display: flex;
    padding: 8px;
`;
